import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { isEmail } from 'validator';
import { toast } from 'react-toastify';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';

import store from '../store/store';

import 'react-toastify/dist/ReactToastify.css';
import * as actions from '../store/modules/auth/actions';
import { /* SITEKEY */ } from '../config/constantes';

import Card from '../components/card';
import Loading from './loading';
import { Input80px } from '../styles/inputGroup';

const LOGIN_REFRESH_KEY = 'elocoto:refresh-after-login';

export default function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { isLoading, isLoggedIn } = useSelector((state) => state.auth);
  const cancelar = true;

  const { dataLicenca } = store.getState().auth.user;

  const data = new Date();
  const dataAtual = data.getFullYear() + (`00${data.getMonth() + 1}`).slice(-2) + (`00${data.getDate()}`).slice(-2);
  let dataLicencaAtual = '';
  if (dataLicenca) {
    dataLicencaAtual = dataLicenca[0] + (`00${dataLicenca[1]}`).slice(-2) + (`00${dataLicenca[2]}`).slice(-2);
  } else {
    dataLicencaAtual = dataAtual;
  }

  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');

  useEffect(() => {
    const { tipoUsuario } = store.getState().auth.user;
    let destination = '';

    if (tipoUsuario === 'ADMINISTRADOR') {
      destination = '/consultacotacaoadministrador';
    }

    if (tipoUsuario === 'COMPRADOR') {
      destination = dataAtual <= dataLicencaAtual ? '/homecomprador' : '/financeirocomprador';
    }

    if (tipoUsuario === 'VENDEDOR') {
      destination = dataAtual <= dataLicencaAtual ? '/homevendedor' : '/financeirovendedor';
    }

    if (isLoggedIn && destination && sessionStorage.getItem(LOGIN_REFRESH_KEY)) {
      sessionStorage.removeItem(LOGIN_REFRESH_KEY);

      const url = new URL(window.location.href);
      url.searchParams.set('_refresh', Date.now().toString());
      url.hash = destination;
      window.location.replace(url.toString());
      return;
    }

    if (isLoggedIn && destination) {
      navigate(destination);
    }
  }, [isLoggedIn, navigate, dispatch, dataAtual, dataLicencaAtual]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    let formErros = false;

    if (!isEmail(email)) {
      formErros = true;
      toast.error('Email inválido.');
    }

    if (senha.length <= 0) {
      formErros = true;
      toast.error('Senha deve ser informada.');
    }

    if (formErros) return;
    const captcha = '';

    sessionStorage.setItem(LOGIN_REFRESH_KEY, 'true');
    dispatch(actions.loginRequest({ email, senha, captcha }));
  };

  const handleNewUser = () => {
    navigate('/cadastrousuariologin');
  };

  const handleNewSenha = () => {
    navigate('/novasenha');
  };

  return (
    <div className="login-page">
      <Loading isLoading={isLoading} cancelar={cancelar} />
      <div className="login-card-wrap">
        <div className="bs-docs-section">
          <Card title="Acesse sua conta" largura="600px">
            <p className="login-subtitle">Use suas credenciais para continuar.</p>
            <div className="row">
              <div className="col-12">
                <div className="bs-component">
                  <div className="row form-elo login-field-row">
                    <div className="col-12">
                      <div className="p-inputgroup login-inputgroup">
                        <Input80px className="p-inputgroup-addon">
                          <i className="pi pi-envelope" />
                        </Input80px>
                        <InputText
                          id="inputEmail"
                          maxLength={254}
                          value={email}
                          onChange={e => setEmail(e.target.value)}
                          placeholder="seu@email.com"
                          autoComplete="email"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row form-elo login-field-row">
                    <div className="col-12">
                      <div className="p-inputgroup login-inputgroup">
                        <Input80px className="p-inputgroup-addon">
                          <i className="pi pi-lock" />
                        </Input80px>
                        <Password
                          toggleMask
                          feedback={false}
                          id="inputSenha"
                          maxLength={50}
                          value={senha}
                          onChange={e => setSenha(e.target.value)}
                          placeholder="Digite sua senha"
                          autoComplete="current-password"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 login-actions">
                <button type="button" className="btn btn-primary login-submit login-primary-action" onClick={handleSubmit}>
                  Entrar <i className="pi pi-arrow-right"></i>
                </button>
                <div className="login-secondary-actions">
                  <button type="button" className="btn login-secondary-action" onClick={handleNewUser}>
                    <i className="pi pi-user-plus"></i> Cadastrar
                  </button>
                  <button type="button" className="btn login-link-action" onClick={handleNewSenha}>
                    <i className="pi pi-key"></i> Esqueci a senha
                  </button>
                </div>
              </div>
              { /* <div className="col-lg-12">
                <div className="bg-white p-8 rounded-2xl shadow-lg max-w-md w-full text-center border-t-4 border-yellow-500">
                  <h1 className="text-3xl font-bold text-gray-800 mb-4"> Aviso de Manutenção </h1>
                  <p className="text-gray-700 text-lg">
                    Prezados usuários, informamos que uma manutenção essencial em nossos serviços está programada para iniciar às
                    <strong className="text-yellow-600"> 14h do dia 30 de Agosto.</strong>
                  </p>
                  <p>
                    Os serviços serão reestabelecidos após a conclusão dos trabalhos no
                    <strong className="text-yellow-600"> final do dia 31 de Agosto. </strong>
                    Contamos com sua paciência e colaboração.
                  </p>
                  <p className="text-gray-600 text-sm mt-4"> Agradecemos a sua compreensão. </p>
                  <hr />
                </div>
              </div> */}
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
}
